//#region IMPORTS
import {
  fetchInstoreTemplateAsync,
  instoreTemplatesSelectors,
} from "./instoreTemplatesSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { fetchInstoreThemesAsync } from "../instoreThemes/instoreThemesSlice";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import InstoreTemplateDetailContainer from "../../components/instoreTemplateDetail/InstoreTemplateDetailContainer";
//#endregion

//#region INTERFACE
interface Props {
  create?: boolean;
  copy?: boolean;
}
//#endregion

export default function InstoreTemplateDetailPage({
  create = false,
  copy = false,
}: Props) {
  //#region SETUP
  // Router
  const { id } = useParams<{ id: string }>();

  // Redux
  const dispatch = useAppDispatch();
  const { instoreThemes_Loaded } = useAppSelector(
    ({ instoreThemes }) => instoreThemes
  );

  const instoreTemplate = useAppSelector((state) =>
    instoreTemplatesSelectors.selectById(state, id)
  );
  //#endregion

  //#region LOGIC
  useEffect(() => {
    const fetchData = async (id: number) => {
      await dispatch(fetchInstoreTemplateAsync(id));
    };
    id && !create && fetchData(Number(id));
  }, [id, create, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchInstoreThemesAsync());
    };
    !instoreThemes_Loaded && fetchData();
  }, [instoreThemes_Loaded, dispatch]);
  //#endregion

  //#region RENDER
  return (
    <InstoreTemplateDetailContainer
      instoreTemplate={instoreTemplate}
      copy={copy}
      create={create}
    />
  );
  //#endregion
}
